
import { defineComponent, ref, onMounted } from "vue";
import ApiService from "@/core/services/ApiService";
import { useStore } from "vuex";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import AddTaskModal from "@/components/modals/general/AddTaskModal.vue";
import AdminTaskDrawer from "@/layout/extras/AdminTaskDrawer.vue";
import { DrawerComponent } from "@/assets/ts/components/_DrawerComponent";

export default defineComponent({
  name: "admin-tasks",
  components: {AddTaskModal, AdminTaskDrawer},
  props: {
    widgetClasses: String,
  },
  setup() {
    const merchantTaskListTotal = ref(0);
    const merchantTaskList = ref([]);
    const tasksCenterListTotal = ref(0);
    const tasksCenterList = ref([]);
    const store = useStore();
    const loading = ref(false);

    onMounted(async() => {
      setTimeout(async () => {
        await getTaskCenterList();
         DrawerComponent.reinitialization();

      }, 1000);
    });
    const getTaskCenterList = async () => {
      loading.value = true;
      const res2 = await ApiService.get(
        `merchants/task.center?group_id=IN${store.getters.currentUser.data.group_owners}`
      );
      tasksCenterList.value = res2.data.data;
      tasksCenterListTotal.value = res2.data.meta.total;

      loading.value = false;
    };
    const getMerchantTaskList = async (val) => {
      loading.value = true;
      const res2 = await ApiService.get(
        `merchants/tasks?merchant_id=${val}`
      );
      merchantTaskList.value = res2.data.data;
      merchantTaskListTotal.value = res2.data.meta.total;

      loading.value = false;
    };
    const checked = ref(false);

    const submit = async (index, status, text, color) => {
      let payload: any = '';
      loading.value = true;
      try {
        const res = await ApiService.put(
          `merchants/tasks/${index}?reviewed=1&status=${status}&text=${text}&color=${color}`,
          payload
        );
        if (res.data.success) {
          Swal.fire({
            text: "Task Reviewed!",
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-primary",
            },
          }).then(function () {
            getTaskCenterList();
          });
        } else {
          Swal.fire({
            text: res.data.error.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Try again!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          });
        }
      } catch (e) {
        Swal.fire({
          text: e.response.data.error
            ? e.response.data.error.message
            : "Something went wrong!",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Try again!",
          customClass: {
            confirmButton: "btn fw-bold btn-light-danger",
          },
        });
      }
      loading.value = false;
    };
    const selectedMerchant = ref({});

    const openDrawer = (val) => {
      selectedMerchant.value = val;
      DrawerComponent?.getInstance("admin_task_drawer")?.show();
    };
    const onUpdateMerchantTask = () => {
      getTaskCenterList();
    };

    return {
      openDrawer,
      submit,
      getTaskCenterList,
      getMerchantTaskList,
      tasksCenterList,
      tasksCenterListTotal,
      merchantTaskList,
      merchantTaskListTotal,
      checked,
      selectedMerchant,
      onUpdateMerchantTask,

    };
  },
});
